module.exports = __webpack_public_path__ + "static/media/download-android.43885b06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/begamer/download-android.jpg
// module id = 971
// module chunks = 0